export default function getFilteredVHRTiles(productTiles, carfaxReportUrl, isOverrideCarfaxTileEnabled) {
    const whiteLabelCarfaxTile = {
        clickable: true,
        epn: 'carfaxVHR',
        link: {
            href: carfaxReportUrl,
            offsite: 'true',
            partner: true,
        },
        tileType: 'CARFAX_APPENDED',
        visible: true,
        image: {
            src: '/cm-api/content/static/img/vhr/carfax/regular-own.svg',
        },
    };
    // VHR Variables
    const filteredVHRTiles = productTiles?.filter((tile) => !isOverrideCarfaxTileEnabled && tile.tileType.startsWith('CARFAX') || tile.tileType.startsWith('EXPERIAN'));
    if (isOverrideCarfaxTileEnabled && filteredVHRTiles) {
        filteredVHRTiles.push(whiteLabelCarfaxTile);
    }

    return filteredVHRTiles;
}
